import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

const Captcha = (props) => {
  return (
    <div className='d-inline-block my-auto pb-2'>
      <ReCAPTCHA
        // sitekey="6LeGZ0AUAAAAAJj4VM1gqkds0-yQfnUi7egtEQvn"
        sitekey='6LfToL4qAAAAAO6Wlm95mNf6dFDzea47rY5RAzM1'
        onChange={(response) => {
          props.input.onChange(response);
        }}
      />
      {props.meta.touched && props.meta.error && (
        <span className='text-danger'>{props.meta.error}</span>
      )}
    </div>
  );
}

Captcha.propTypes = {
  input: PropTypes.object.isRequired
};

export default Captcha;



// WEBPACK FOOTER //
// ./src/components/Captcha.js